










import {Component, Vue} from 'vue-property-decorator';
import FullDialog from '@/components/UI/FullDialog.vue';
import FullPlan from "@/components/UI/FullPlan.vue";
import ModalSupport from "@/components/UI/ModalSupport.vue";

@Component({
  name:"None",
  components: {
    FullDialog,
    FullPlan,
    ModalSupport,
  }
})
export default class None extends Vue{

}
